<template>
    <div class="config-box-title" flex="cross:center main:justify">
        <div class="box-title" flex="cross:center"><span></span>{{title}}</div>
        <div class="btns" flex="cross:center" v-if="needType">
            <div class="btn" :class="{active: type == 1}" @click="changeType(1)">内容</div>
            <div class="btn" :class="{active: type == 2}" @click="changeType(2)">样式</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        needType: {
            type: Boolean,
            default: true
        }
    },
    data(){
        return {
            type: 1,
        }
    },
    methods: {
        changeType(type){
            this.type = type
            this.$emit('change', type)
        }
    }
}
</script>

<style scoped lang="scss">
@import '../assets/sass/variables';

    .config-box-title{
        padding-bottom: 15px;
        border-bottom: 1px solid #eee;
        margin-bottom: 15px;
        .box-title{
            font-size: 16px;
            span{
                display: inline-block;
                width: 3px;
                background: $c-primary;
                height: 16px;
                margin-right: 10px;
                border-radius: 2px;
            }
        }
        .btns{
            .btn{
                width: 50px;
                height: 26px;
                border: 1px solid #ddd;
                text-align: center;
                line-height: 26px;
                color: $c-info;
                cursor: pointer;
                &:last-child{
                    border-left: 0;
                    border-radius: 0 15px 15px 0;
                }
                &:first-child{
                    border-right: 0;
                    border-radius: 15px 0 0 15px;
                }
                &.active{
                    background: $c-primary;
                    color: #fff;
                    border-color: $c-primary;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/ConfigBoxTitle.vue